<template>
<div class="">
    <!-- Slider background based on https://github.com/avidofood/vue-responsive-video-background-player -->
    <video-background
            :src='require("../assets/images/video.mp4")'
            poster="../assets/images/bg-slide.jpg"
            :sources="[
        // {src: require('../assets/images/video.mp4'), res: 900, autoplay: true},
        {src: require('../assets/images/mob.mp4'), res: 638, autoplay: true, poster: '../assets/images/bg-slide.jpg'}
    ]"
            style="max-height: 493px; height: 150vh;"
            overlay="linear-gradient(45deg,#2a4ae430,#fb949e6b)"
    >
        <section class="slider py-0">
            <div id="home-slider" class="owl-carousel owl-theme">
                <div v-for="slide in slides" :key="slide.nid" class="item bg-cover overlay-fill" :style="{backgroundImage: `url(${slide.field_main_slider_image})`}">
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-12 col-lg-8">
                                <div class="slider-content text-center text-white" v-if="slide.body">
                                    <h1 class="text-white">{{ slide.body }}</h1>
                                    <span> <a class="read-more" href=""> Find out more </a>  </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- End Slider -->
    </video-background>
</div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import VideoBackground from 'vue-responsive-video-background-player';
Vue.component('video-background', VideoBackground);

export default {
    name: 'HomeSlider',
    data(){
        return {
            slides: [],
        }
    },
    components:{
        VideoBackground
    },
    mounted () {
        axios
        .get('https://api.fifmi.org.au/api/sliders')
        .then(result => {
            for (var i = 0; i < result.data.length; i++) {
                if(result.data[i].field_domain_access.includes('fifmi') && result.data[i].type == "slider"){
                    this.slides.push(result.data[i]);
                }
            }
        });
    },
    updated() {
        this.$nextTick(function () {
            $('#home-slider').owlCarousel({
                loop:true,
                margin:0,
                items: 1,
                nav:true,
                dots: false,
            })
            $( "#home-slider .owl-prev").html('<i class="fa fa-angle-double-left"></i>');
            $( "#home-slider .owl-next").html('<i class="fa fa-angle-double-right"></i>');
        });
    },
}
</script>
